import { autoserialize, inheritSerialization } from 'cerialize';
import { AbstractModel } from './abstract-model';

@inheritSerialization(AbstractModel)
export class Sublocation extends AbstractModel {
  @autoserialize
  locationId: number;

  @autoserialize
  name: string;

  @autoserialize
  description: string;

  @autoserialize
  latitude: number;

  @autoserialize
  longitude: number;
}
